import { render, staticRenderFns } from "./TopProdutos.vue?vue&type=template&id=2553c8fa&scoped=true"
import script from "./TopProdutos.vue?vue&type=script&lang=js"
export * from "./TopProdutos.vue?vue&type=script&lang=js"
import style0 from "./TopProdutos.vue?vue&type=style&index=0&id=2553c8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2553c8fa",
  null
  
)

export default component.exports